import React from 'react'

import Home from "./home"

const index = props => {
    return <Home {...props} />
}

export default index
